<template>
    <div class="title-block">
        <div class="title-block__left">
            <button @click="addModalIsOpen = true" class="title-block__btn btn-add btn-primary btn" type="button">
                Добавить
            </button>
        </div>
    </div>

    <div class="filter-table">
        <div class="filter-table__input-wrap search-control">
            <input v-model="forms.numberContract.value"
                   @keyup.enter="onSearchByNumber()"
                   @keyup.delete="onCancelSearchByNumber()"
                   type="text"
                   class="search-control__input form-control"
                   placeholder="Поиск по номеру договора">
            <button @click="onSearchByNumber()" class="search-control__input-btn reset-btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5" stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <div class="filter-table__list-wrap">
            <ul class="filter-table__list">
                <li class="filter-table__item">
                    <v-select class="ftoggle"
                              @update:modelValue="onChangeFilter"
                              v-model="primaryFilterVal"
                              :options="primaryFilter"
                              :searchable="false"
                              :deselectFromDropdown="false"
                              :appendToBody="true"
                              :calculate-position="withPopper"
                              :clearable="false">
                    </v-select>
                </li>

                <li class="filter-table__item" v-show="primaryFilterVal === 'Лицензиат'">
                    <select @change="onChangeOrg($event)" v-model="forms.organization.selected" class="search-control__input form-control">
                        <option selected value="">
                            Все
                        </option>
                        <option v-for="organization in forms.organization.items" v-bind:value="organization.id">
                            {{ organization.name }}
                        </option>
                    </select>
                </li>

                <li class="filter-table__item" v-show="primaryFilterVal === 'Клиент'">
                    <select @change="onChangeClient($event)" v-model="forms.client.selected" class="search-control__input form-control">
                        <option selected value="">
                            Все
                        </option>
                        <option v-for="client in forms.client.items" v-bind:value="client.id">
                            {{ client.name }}
                        </option>
                    </select>
                </li>
            </ul>
        </div>
    </div>

    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th style="width: 36px; padding-right: 0"></th>
                    <th>Тип документа</th>
                    <th class="text-center">Дата</th>
                    <th class="text-center">Клиент</th>
                    <th class="text-center">Лицензиар</th>
                    <th class="text-center">Лицензиат</th>
                    <th class="text-center">Действия</th>
                </tr>
            </thead>
            <tbody>
            <template v-for="contract in tables.contracts.items">
                <template v-if="contract.is_open == true">
                    <tr>
                        <td style="width: 36px; padding-right: 0">
                            <button v-if="contract.additionally_contracts.length > 0"
                                    @click="closeContract(contract.contract_id)"
                                    class="table-switch is-selected"
                                    type="button"
                                    title="Развернуть/Свернуть">
                            </button>
                        </td>
                        <td>
                            <div class="table-item-group">
                                <div class="table-icon-item me-2">
                                    <!-- Сюда можно и svg вставить с таким классом -->
                                    <img class="table-icon-item__icon" src="/images/icon_document.svg" alt="">
                                    <span>{{ contract.contract_name }} №{{ contract.contract_number }}</span>
                                </div>
                                <button class="table-add-item" type="button" @click.prevent="addNewAgreement(contract.contract_id)">Добавить документ</button>
                            </div>
                        </td>
                        <td class="text-center">{{ contract.contract_date }}</td>
                        <td class="text-center">{{ contract.client_name }}</td>
                        <td class="text-center">{{ this.licensor }}</td>
                        <td class="text-center">{{ contract.organizations_name }}</td>
                        <td class="text-center">
                            <div class="table-actions table-actions_gap-8px">
                                <a v-bind:href="this.domain + 'documents/' + contract.contract_path" class="table-action table-action_download" title="Скачать" target="_blank"></a>
                                <button @click="goToEditContractPage(contract.contract_id)" class="table-action table-action_edit" title="Редактировать" type="button"></button>
                                <button @click.prevent="showModalDelete(contract.contract_id, 'contract')" class="table-action table-action_delete" @click="deleteModalIsOpen = true" title="Удалить" type="button"></button>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="additionally_contract in contract.additionally_contracts">
                        <td></td>
                        <td>
                            <div class="table-icon-item table-icon-item_sm" style="margin-left: 16px">
                                <!-- Сюда можно и svg вставить с таким классом -->
                                <img class="table-icon-item__icon" src="/images/icon_document.svg" alt="">
                                <span>{{ additionally_contract.name }} №{{ additionally_contract.number }}</span>
                            </div>
                        </td>
                        <td class="text-center">{{ additionally_contract.date }}</td>
                        <td class="text-center">{{ additionally_contract.client.name }}</td>
                        <td class="text-center">{{ this.licensor }}</td>
                        <td class="text-center">{{ additionally_contract.organization.name }}</td>
                        <td class="text-center">
                            <div class="table-actions table-actions_gap-8px">
                                <a v-bind:href="this.domain + 'documents/' + additionally_contract.path" class="table-action table-action_download" title="Скачать" target="_blank"></a>
                                <button @click="goToEditContractAdditionalPage(additionally_contract.id)" class="table-action table-action_edit" title="Редактировать" type="button"></button>
                                <button @click.prevent="showModalDelete(additionally_contract.id, 'additionally-agreement')" class="table-action table-action_delete" @click="deleteModalIsOpen = true" title="Удалить" type="button"></button>
                            </div>
                        </td>
                    </tr>
                </template>
                <template v-if="contract.is_open == false">
                    <tr>
                        <td style="width: 36px; padding-right: 0">
                            <button v-if="contract.additionally_contracts && contract.additionally_contracts.length > 0" @click="openContract(contract.contract_id)" class="table-switch" :class="{'is-selected' : contract.is_open}" type="button" title="Развернуть/Свернуть"></button>
                        </td>
                        <td>
                            <div class="table-item-group">
                                <div class="table-icon-item me-2">
                                    <!-- Сюда можно и svg вставить с таким классом -->
                                    <img class="table-icon-item__icon" src="/images/icon_document.svg" alt="">
                                    <span>{{ contract.contract_name }} №{{ contract.contract_number }}</span>
                                </div>
                                <button class="table-add-item" type="button" @click.prevent="addNewAgreement(contract.contract_id)">Добавить документ</button>
                            </div>
                        </td>
                        <td class="text-center">{{ contract.contract_date }}</td>
                        <td class="text-center">{{ contract.client_name }}</td>
                        <td class="text-center">{{ licensor }}</td>
                        <td class="text-center">{{ contract.organizations_name }}</td>
                        <td class="text-center">
                            <div class="table-actions table-actions_gap-8px">
                                <a v-bind:href="this.domain + 'documents/' + contract.contract_path" class="table-action table-action_download" title="Скачать" target="_blank"></a>
                                <button @click="goToEditContractPage(contract.contract_id)" class="table-action table-action_edit" title="Редактировать" type="button"></button>
                                <button @click.prevent="showModalDelete(contract.contract_id, 'contract')" class="table-action table-action_delete" @click="deleteModalIsOpen = true" title="Удалить" type="button"></button>
                            </div>
                        </td>
                    </tr>
                </template>
            </template>
            </tbody>
        </table>
    </div>

    <pagination-element :count="tables.contracts.count" :current_page="tables.contracts.page" @pageChange="pageChange"></pagination-element>

    <!-- Modal удалить -->
    <div class="modal-mask" v-show="deleteModalIsOpen">
        <div class="modal-wrapper" @click.self="deleteModalIsOpen = false">
            <div class="modal-container">
                <div class="modal-header">
                    <h5 class="modal-title">Удаление документа</h5>
                </div>
                <div class="modal-body">
                    <div class="fw-500">
                        Вы действительно хотите удалить документ?
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="d-flex w-100">
                        <button class="btn btn-md btn-primary flex-grow me-2" type="button" @click.self="deleteItem(modaldata.id, modaldata.document)">
                            Удалить
                        </button>
                        <button class="btn btn-md btn-outline-dark flex-grow" type="button" @click="deleteModalIsOpen = false">
                            Отменить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal добавить -->
    <div class="modal-mask" v-show="addModalIsOpen">
        <div class="modal-wrapper" @click.self="addModalIsOpen = false">
            <div class="modal-container">
                <div class="modal-header">
                    <h5 class="modal-title">Добавить документ</h5>
                </div>
                <div class="modal-footer">
                    <div class="d-flex flex-column w-100 align-items-stretch">
                        <button class="btn btn-md btn-outline-primary mb-2" type="button" @click="create('contract')">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 3v4a1 1 0 001 1h4" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                      stroke-linejoin="round" />
                                <path d="M17 21H7a2 2 0 01-2-2V5a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2zM9 17h6M9 13h6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span>Договор</span>
                        </button>
                        <button class="btn btn-md btn-outline-dark" type="button" @click="create('agreement')">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 3v4a1 1 0 001 1h4" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                      stroke-linejoin="round" />
                                <path d="M17 21H7a2 2 0 01-2-2V5a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2zM9 17h6M9 13h6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span>Доп. соглашение к договору</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Alert />
</template>

<script>

import PaginationElement from '../../../../elements/PaginationElement.vue'
import { dateFormat, withPopper } from '../../../../utilites'
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "ContractsComponent",
    components: {
        PaginationElement,
        Alert
    },
    props: {
        domain: {
            type: [String],
        }
    },
    data() {
        return {
            active: false,
            modals: {
                selectForCreating: {
                    open: false,
                    selectedType: 1
                }
            },
            forms: {
                client: {
                    selected: null,
                    items: []
                },
                organization: {
                    selected: null,
                    items: []
                },
                numberContract: {
                    value: null
                },
            },
            tables: {
                contracts: {
                    items: [],
                    page: 1,
                    limit: 10
                }
            },
            licensor: 'ООО «Цифровые сервисы»',
            modaldata: '',
            addModalIsOpen: false,
            deleteModalIsOpen: false,
            primaryFilterVal: 'Все',
            organization: 'Все',
            client: 'Все',
            primaryFilter: [
                'Все',
                'Клиент',
                'Лицензиат'
            ],
            organizations: [],
            clients: [],
        };
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        dateFormat,
        closeContract: function (contract_id) {
            this.tables.contracts.items = this.tables.contracts.items.map((c) => {
                if (contract_id === c.contract_id) {
                    c.is_open = false;
                }
                return c;
            });
        },
        openContract: function(contract_id) {
            this.tables.contracts.items = this.tables.contracts.items.map((c) => {
                if (contract_id === c.contract_id) {
                    c.is_open = true;
                }
                return c;
            });
        },
        listClients: async function () {
            const data = await axios.get('/organizational/client/list', {}).then(response => {
                return response.data.status === 'ok' ? response.data.items : false
            }).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список список клиентов, что-то пошло не так' });
            });

            if (data) {
                this.forms.client.items = data
            }
        },
        create: function ($document) {
            if ($document === 'contract') {
                window.location.href = '/documents/contracts/create';
            } else if ($document === 'agreement') {
                window.location.href = '/documents/contracts/create-additional';
            }
        },
        listOrgs: async function () {
            let resp = await axios.get('/organizational/organizations/list', {params: {
                    page: 1,
                    limit: 100,
                    client_id: this.forms.client.selected
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список организаций, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.forms.organization.items = resp.data.items;
            }

            if (resp.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
        listContracts: async function () {
            let resp = await axios.get('/documents/contracts/list', {params: {
                    page: this.tables.contracts.page,
                    limit: this.tables.contracts.limit,
                    client_id: this.forms.client.selected,
                    org_id: this.forms.organization.selected,
                    number: this.forms.numberContract.value
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список договоров, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.tables.contracts.items = resp.data.items.map((contract) => {
                    contract.is_open = false;
                    return contract;
                });
                this.tables.contracts.count = resp.data.pages;
            }

            if (resp.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
        goToEditContractPage: function(contract_id) {
            window.location.href = `/documents/contracts/${contract_id}`
        },
        goToEditContractAdditionalPage: function(additionally_contract_id) {
            window.location.href = `/documents/contracts/additional/${additionally_contract_id}`
        },
        showModalDelete: function (id, document) {
            this.modaldata = {id: id, document: document};
        },
        deleteItem: function (id, document_type) {
            axios.delete('/documents/contracts/delete/' + document_type + '/' + id, {})
                .then(res => {
                    if(res.data.status == 'ok') {
                        document.location = '/documents/contracts';
                    }
                });
        },
        addNewAgreement: function (contract_id) {
            window.location.href = `/documents/contracts/create-additional/contract/${contract_id}`
        },
        pageChange: function (newPage) {
            this.tables.contracts.page = newPage;
            this.listContracts();
        },
        onCancelSearchByNumber: async function () {
            if (this.forms.numberContract.value === '') {
                this.tables.contracts.page = 1;
                this.listContracts();
            }
        },
        onSearchByNumber: async function () {
            this.tables.contracts.page = 1;
            this.listContracts();
        },
        onChangeClient: async function (e) {
            this.forms.client.selected = e.target.value;
            this.tables.contracts.page = 1;
            this.listContracts();
        },
        onChangeOrg: async function (e) {
            this.forms.organization.selected = e.target.value;
            this.tables.contracts.page = 1;
            this.listContracts();
        },
        onChangeFilter: async function(filter) {
            if (filter === 'Все') {
                this.tables.contracts.page = 1;
                this.forms.client.selected = null;
                this.forms.organization.selected = null;
                this.listContracts();
            }
        },
        withPopper,
    },
    async mounted() {
        await this.listContracts();
        await this.listClients();
        await this.listOrgs();
    }
};
</script>